import { render } from "./RicercaAuto.vue?vue&type=template&id=02283f96"
import script from "./RicercaAuto.vue?vue&type=script&lang=js"
export * from "./RicercaAuto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__